import axios from 'axios';

export interface UserMetaData {
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  emailVerified: boolean;
  emailAlias: string | null;
  company: string | null;
  jobTitle: string | null;
  phoneNumber: string | null;
  photoId: string | null;
}

export interface GetUserProfilesResponse {
  [userId: string]: UserMetaData;
}

export interface UserMetadataServerProxy {
  getUserProfiles: (userIds: string[]) => Promise<GetUserProfilesResponse>;
}

export const userMetadataServerProxy: UserMetadataServerProxy = {
  getUserProfiles: async (userIds) => {
    const response = await axios.post<GetUserProfilesResponse>('/api/user/GetUserProfilesFromUserIds', userIds);
    return response.data;
  }
};
